import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  GkComponentsModule,
  GkDynamicListModule,
  GkMapModule,
} from '@gk/gk-modules';
import { SharedModule } from '../../shared/shared.module';
import { ExtractCertificateFromLocalSpatialDevelopmentPlanOrStudyRequestComponent } from './extract-certificate-from-local-spatial-development-plan-or-study-request/extract-certificate-from-local-spatial-development-plan-or-study-request.component';
import { PlanningDepartmentRoutingModule } from './planning-department-routing.module';
import { PlanningDepartmentComponent } from './planning-department.component';
import { ExtractCertificateFeeService } from './services/extract-certificate-fee/extract-certificate-fee.service';
import { ECNewRequestFormService } from './services/new-request-form/new-request-form.service';

@NgModule({
  imports: [
    CommonModule,
    PlanningDepartmentRoutingModule,
    SharedModule,
    GkMapModule,
    GkComponentsModule,
    GkDynamicListModule,
  ],
  declarations: [
    PlanningDepartmentComponent,
    ExtractCertificateFromLocalSpatialDevelopmentPlanOrStudyRequestComponent,
  ],
  providers: [ECNewRequestFormService, ExtractCertificateFeeService],
})
export class PlanningDepartmentModule {}
